'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import PortalIdParser from 'PortalIdParser';
import Raven from 'Raven';
import HomeDAO from '../data/HomeDAO';
import Loading from '../templates/Loading';
import _redirect from '../utils/redirect';
import { error, login } from '../utils/urls';

var RootEntry = /*#__PURE__*/function () {
  function RootEntry() {
    _classCallCheck(this, RootEntry);
  }

  _createClass(RootEntry, [{
    key: "start",
    value: function start() {
      var _this = this;

      PortalIdParser.getPortalIdFromQueryParam();
      this.page = document.getElementsByClassName('page')[0];
      this.renderLoading();
      HomeDAO.getUserPortalId(function (_ref) {
        var portalId = _ref.portalId;
        return _this.redirect(portalId);
      }, function () {
        return _this.redirect();
      });
    }
  }, {
    key: "redirect",
    value: function redirect() {
      var _this2 = this;

      var portalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      HomeDAO.get(portalId, function (_ref2) {
        var uri = _ref2.uri;
        return _redirect(uri);
      }, function (errorResp) {
        return _this2.homeFailure(errorResp);
      });
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      this.page.appendChild(Loading());
    }
  }, {
    key: "homeFailure",
    value: function homeFailure(errorResp) {
      if (errorResp.status === 400 || errorResp.status === 401 || errorResp.status === 403) {
        _redirect(login(PortalIdParser.getPortalIdFromQueryParam()));
      } else {
        Raven.captureMessage('Home api error', {
          extra: {
            readyState: errorResp.readyState,
            responseText: errorResp.responseText,
            responseURL: errorResp.responseURL,
            status: errorResp.status,
            statusText: errorResp.statusText
          }
        });

        _redirect(error());
      }
    }
  }]);

  return RootEntry;
}();

new RootEntry().start();